import { arrow, toolTip } from '../styles/legacy';
import { arrow as arrowCitrus2022, toolTip as toolTipCitrus2022 } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Arrow = citrusStyled.div('arrow', { legacy: arrow, citrus2022: arrowCitrus2022 });
export var Tooltip = citrusStyled.div('toolTip', { legacy: toolTip, citrus2022: toolTipCitrus2022 });
export var Styled = {
    Arrow: Arrow,
    Tooltip: Tooltip,
};
